<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="search"/>
          {{ $t('customerLookup') }}
        </h1>
      </div>
    </div>
    <div>
      <div class="row">
        <div class="col-12">
          <div class="tile">
            <div class="form-inline">
              <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="load"
                            :placeholder="$t('enterNumber')" @change="search"></b-form-input>
              <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
              <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
            </div>
          </div>
        </div>
      </div>
      <client-table :filter="filterFormModel" ref="clientTable"></client-table>
      <customer-table class="mt-4" :filter="filterFormModel" ref="customerTable"></customer-table>
    </div>
  </main>
</template>

<script>
import _ from 'lodash';
import ClientTable from "@/views/lookup/ClientTable.vue";
import CustomerTable from "@/views/lookup/CustomerTable.vue";

export default {
  components: {ClientTable, CustomerTable},
  data() {
    return {
      filterFormModel: {
        keyword: null,
      },
    }
  },
  methods: {
    search: _.debounce(function () {
      this.filterFormModel.page = 1;
      this.load();
    }, 200),
    load() {
      this.$refs.clientTable.load()
      this.$refs.customerTable.load()
    },
    reset() {
      this.filterFormModel.keyword = null;
      this.load()
    }
  },
  i18n: {
    messages: {
      en: {
        phone: 'Phone number',
        user: 'Agent',
        startTime: 'Start time',
        answerTime: 'Answer time',
        endTime: 'End time',
        billDuration: 'Bill duration',
        notFoundSearch: 'No result found! Change your search condition and try again!',
        fromNumber: 'From number',
        toNumber: 'To number',
        gateway: 'Gateway',
        enterNumberNote: "Please enter customer phone number!",
        customerLookup: "Look up customers",
        enterNumber: "Enter phone number",
        direction: "Calling direction",
        clientInfo: "Client information",
        callInfo: "Call information"
      },
      vi: {
        phone: 'SĐT',
        user: 'Nhân viên',
        startTime: 'Gọi lúc',
        answerTime: 'Trả lời',
        endTime: 'Kết thúc',
        billDuration: 'Thời gian đàm thoại',
        notFoundSearch: 'Không tìm thấy kết quả nào! Hãy thay đổi điều kiện tìm kiếm và thử lại!',
        fromNumber: 'Gọi từ SĐT',
        toNumber: 'Gọi tới SĐT',
        gateway: 'Gateway',
        enterNumberNote: "Xin hãy nhập số điện thoại khách hàng!",
        customerLookup: "Tra cứu khách hàng",
        enterNumber: "Nhập số điện thoại",
        direction: "Hướng gọi",
        clientInfo: "Thông tin client",
        callInfo: "Thông tin cuộc gọi"
      }
    }
  }
}
</script>